import { HamburgerIcon } from "@chakra-ui/icons";
import {
  Center,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  SimpleGrid,
} from "@chakra-ui/react";
import React from "react";

export interface QuickRowAction<TableRowType> {
  title: string;
  action: (rows: TableRowType) => void;
  icon: React.ReactNode;
}

export interface RowAction<TableRowType> {
  label: string;
  action: (rows: TableRowType) => void;
  icon?: React.ReactNode;
  disabled?: (rows: TableRowType) => boolean;
}

export interface RowActionsMenuProps<TableRowType> {
  buttonVariant: string;
  row: TableRowType;
  actions: RowAction<TableRowType>[];
}

export function RowActionsMenu<TableRowType>({
  row,
  actions,
  buttonVariant,
}: RowActionsMenuProps<TableRowType>) {
  const completelyDisabled = actions.every((action) => action.disabled && action.disabled(row));

  return (
    <Center>
      <Menu autoSelect={false}>
        <MenuButton
          transition="all 0s"
          width="10px"
          as={IconButton}
          aria-label="Actions"
          icon={<HamburgerIcon />}
          variant={buttonVariant}
          isDisabled={completelyDisabled}
        />
        <MenuList transition="all 0s">
          {actions.map((action, idx) => (
            <MenuItem
              key={idx}
              onClick={() => action.action(row)}
              isDisabled={action.disabled && action.disabled(row)}
            >
              <SimpleGrid columns={2} templateColumns="30px 1fr">
                <span>{action.icon ?? ""}</span>
                <span>{action.label}</span>
              </SimpleGrid>
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Center>
  );
}
